import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import locale from 'antd/es/locale/ja_JP';
import App from './App';
import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { queryClient } from 'utils/reactQueryClient';
import AuthProvider from 'utils/AuthProvider';
import { ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import ChatProvider from 'utils/ChatProvider';
import VideoCallProvider from 'utils/VideoCallProvider';
import { QueryParamProvider } from 'use-query-params';
import NotificationProvider from 'utils/NotificationProvider';
import { LoadingDialogProvider } from 'components/Loading/LoadingDialog';
import dayjs from 'dayjs';
import jaLocale from 'dayjs/locale/ja';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import './i18n/config'; // Initialize i18n

// Extend dayjs with required plugins for antd DatePicker
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

// Set locale to Japanese (week starts Monday; default ja omits weekStart → Sunday)
dayjs.locale('ja', { ...jaLocale, weekStart: 1 });

// Ensure document language is set to Japanese for browser/system features (e.g., iOS password prompts)
if (document.documentElement) {
  document.documentElement.lang = 'ja';
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ConfigProvider locale={locale}>
      <BrowserRouter>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
              <AuthProvider>
                <ChatProvider>
                  <VideoCallProvider>
                    <NotificationProvider>
                      <LoadingDialogProvider>
                        <App />
                      </LoadingDialogProvider>
                    </NotificationProvider>
                  </VideoCallProvider>
                </ChatProvider>
              </AuthProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </QueryParamProvider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
